import { ArchiveMutation } from "../../../hooks/useArchiveState";
import { RosTemplateControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 * @author [Rajkumar Rathod]
 */
export const useFormTemplateArchiveStatusV2 = () =>
  useMutationWithLoading(async (param: ArchiveMutation) =>
    new RosTemplateControllerApi(getConfigObject()).updateRosArchiveStatus(
      param.id,
      param.status,
      param?.xTENANTID
    )
  );
